import type { JSX, PropsWithChildren } from 'react';

// eslint-disable-next-line internal-rules/no-restricted-design-system-imports
import { Button, Text } from '@change/ds-core-ui';

import { useQRCode } from 'src/app/shared/hooks/qrcode';

type QRCodeDownloadLinkProps = PropsWithChildren<{
	value: string;
	size?: number;
	filename?: string;
	onDownload?: () => Promise<void>;
}>;
/**
 * Renders a link to download a QR code with the given value.
 * The QRCode is not visible, but is used to download a hi-res version of the QRCode
 */
export function QRCodeDownloadLink({
	children,
	value,
	size = 512,
	filename,
	onDownload,
}: QRCodeDownloadLinkProps): JSX.Element {
	const { data } = useQRCode({ value, size });

	const handleDownload = async () => {
		await onDownload?.();
	};

	return (
		<Button
			as="a"
			download={filename || true}
			href={data ?? '#'}
			onClick={handleDownload}
			variant="secondary"
			size="small"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			<Text variant="body" size="medium" fontWeight="bold">
				{children}
			</Text>
		</Button>
	);
}
